<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="part" style="margin-top:20px;">“But as you already know your rights and privileges so well, I am going to ask you to excuse me if I say a few words to you about your duties. Much has been given to us … and we must take heed to use aright the gifts entrusted to our care. It is not what we have that will make us a great nation; it is the way in which we use it. I do not undervalue for a moment our material prosperity; like all Americans, I like big things; big prairies, big forests and mountains, big wheat fields, railroads … big factories, steamboats, and everything else. But we must keep steadfastly in mind that no people were ever yet benefited by riches if their prosperity corrupted their virtue.”</p>
<blockquote>
<p class="ind">July 4, 1886:</p>
<p class="ind">Hon. Theodore Roosevelt,</p>
<p class="ind">addressing the first</p>
<p class="ind">Independence Day celebration</p>
<p class="ind">in Dickinson,</p>
<p class="ind">Dakota Territory</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6part.vue?64667998